<template>
    <div :class="loading? 'margin_alto' : 'margin_normal'">
        <!-- Spiner -->
        <spiner v-show="loading"></spiner>
        <h6 v-show="loading" class="text-center text-muted text-cargando"> Cargando contenido...</h6>

        <div v-show="!loading" class="container my-4">
            <!-- =====CONTENEDOR IMAGEN Y MENSAJE DEL SRIO===== -->
            <div class="contenedor-sh-mensaje">
                <mensaje></mensaje>
            </div>
            <div class="contenedor-sh-mensaje d-none">
               <!-- Contenedor imagen de secretario -->
                <div class="img_sh">
                    <img src="@/assets/imagenes/imagen_secretario.jpg" alt="">
                </div>
                <!-- contenedor mensaje -->
                <div class="mensajesh_bienvenida">
                    <!-- cuerpo de texto -->
                    <p class="mb-3">Bienvenidos al Portal de Internet de la Secretaría de Hacienda del Estado de Chiapas; 
                        un sitio que hemos renovado con el único fin de servirte mejor, al acercarte los trámites 
                        y servicios de manera más rápida y sencilla.</p>  
                    <p class="mb-3">Esta Administración encabezada por el Dr. Rutilio Escandón Cadenas le apuesta a la 
                    modernización tecnológica, pues es un factor de cambio en la forma que como gobierno 
                    le respondemos de manera eficiente a la demanda ciudadana.</p>  
                    
                    <p class="mb-3">Los que formamos parte del Equipo de la Secretaría de Hacienda del Estado de 
                    Chiapas, estamos comprometidos con el Proyecto de Gobierno 2018-2024 al promover 
                    la transparencia en el deber hacendario y con ello buscar el beneficio de nuestro bello 
                    Estado.</p>          
                    <p class="mb-3">Reiteramos nuestro compromiso de seguir mejorando cada día, muchas gracias…</p>        
                    <!-- <span class="nombre-srio">Dr. Javier Jiménez Jiménez</span> -->
                </div>
            </div>
            <!-- CONTENEDOR DATOS DEL SRIO y SRIA DE HACIENDA -->
            <div v-if="data" class="datos-srio-hacienda">
                <div class="linea"></div>
                <!-- datos secretario -->
                <div class="secretario">
                    <h3>{{data.organopadre.encargado.funcionario}}</h3>
                    <h3>Secretario de Hacienda del Estado de Chiapas</h3>
                    <!-- <p>{{data.organopadre.encargado.organo}}<br> -->
                    <p>Conmutador: {{data.organopadre.encargado.conmutador}} <br>
                    Correo: {{data.organopadre.encargado.correo}}</p>
                </div>
                <!-- Datos secretaría -->
                <div class="hacienda">
                    <div class="logo-hacienda">
                        <img src="@/assets/imagenes/directorio_escudo.png" alt="">
                    </div>
                    <div class="datos-hacienda">
                        <h3>{{data.organopadre.dependencia.Organo}}</h3>
                        <p>{{data.organopadre.dependencia.domicilio}} <br>
                        {{data.organopadre.dependencia.colonia}} C.P. {{data.organopadre.dependencia.cp}} {{data.organopadre.dependencia.cp}} {{data.organopadre.dependencia.municipio}}, Chiapas  <br>
                        Conmutador: {{data.organopadre.dependencia.conmutador}} <br>
                        <a href="">{{data.organopadre.dependencia.web}}</a></p>
                    </div>
                </div>
            </div>
            <!-- CONTENEDOR DEL SWITCH -->
            <div>
                <p class="text-busqueda">Busqueda por:</p>
            </div>
            <div class="contenedor-opcBusqueda">                                 
                <div class="center con-switch">
                    <vs-switch :color="color" style="width:190px; height:31px; background-color: #ad985f" v-model="toggle">
                        <span class="opc1" slot="on">Funcionario</span>
                        <span class="opc2" slot="off">Órgano</span>
                    </vs-switch>                
                </div>      
            </div>
            <!-- <p>Valor del switch: {{toggle}}</p> -->
            <!-- =====BUSQUEDA POR ORGANO===== -->
            <div v-show="!toggle" class="opc-organo">
                <div class="contenedor-busquedaOrgano">
                    <div class="select-organo">
                        <select  class="js-example-basic-single custom-select custom-select-lg" id="listaOrganos"></select>
                    </div>
                    <div class="boton-organo">
                        <button @click="obtenerNieto" class="btn btn-vino btn-block" style="padding:.5rem; height:100%;">Consultar</button>
                    </div>
                </div>
                <p style="" id="error1" class="d-none error-estilos">*Debe seleccionar un Órgano</p>
            <!-- Area de collapses con los organos -->
                <div v-if="verCollapse">
                    <!-- Ciclo solo para mostrar los datos del hijo de Hacienda seleccionado -->
                    <div v-for="(hijo, x) in data.organoshijos[0][nombreHijo]" :key="x"> <!---Seleccionar  el objeto donde se encuentre el otro objeto con el organo hijo que se selecciono en el select por medio de su NUMERO DE INDICE ---->
                        <div v-if="hijo.IDPadre === 43"> <!----Seleccionar el organo que su padre directo sea hacienda, sin esta condición me imprime los demás objetos vacios que tienen los nietos de Hacienda----->
                            <!-- Datos del hijo de Hacienda seleccionado -->
                            <div v-if="hijo.Funcionario != null">
                                <div class="datos_hijo">
                                    <p style="color: #560f2c; font-size: 18px;">{{hijo.Organo}}</p>
                                    <p style="font-weight:bolder;">{{hijo.Funcionario}}</p>
                                    <p>{{hijo.conmutador}}<span v-if="hijo.conmutador && hijo.telefonodirecto"> - </span> {{hijo.telefonodirecto}}</p>
                                    <p>{{hijo.Correo}}</p>
                                    <p>{{hijo.domicilio}} {{hijo.colonia}} C.P. {{hijo.cp}} {{hijo.municipio}} </p>
                                </div>
                                <h1 class="OrganoTitulo">Direcciones que pertenecen a este Órgano Administrativo:</h1>
                            </div>
                            <div v-else>
                                <h1 class="OrganoTitulo">{{hijo.Organo}}</h1>
                            </div>
                        </div>                
                    </div>
                    <!-- seccion collapses -->
                    <div class="container my-4">
                        <div class="accordion mt-4" id="accordionExample">
                            <!-- Ciclo para mostrar nietos y bisnietos de hacienda -->                
                            <!-- aqui van los ciclos  -->
                            <div v-for="(organos_hijos, a) in data.organoshijos[0][nombreHijo] " :key="a" >
                                <div v-for="(nieto, h) in organos_hijos" :key="h">
                                    <div v-if="nieto"> <!----Condición que me permite acceder a los atributos de "nieto" sin marcar error (bug)---->
                                        <div v-show="h== nieto.nombredependencia"><!-----Para eliminar los datos innecesarios y que solo imprima las direcciones------>
                                            <div class="card card-padre">
                                                <div class="card-header" :id="'heading'+a" style="/*background: #f0f0f0;*/">
                                                    <h2 class="mb-0">
                                                        <button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" :data-target="'#collapse'+a" aria-expanded="true" :aria-controls="'collapse'+a" style="display:flex; justify-content:space-between;">
                                                        <span>{{nieto.nombredependencia}}</span>
                                                        <span class="descargar" style="font-size:1.5rem;"><i class='bx bx-chevron-down icono-down' style="color: #560f2c;"></i></span>
                                                        </button>
                                                    </h2>
                                                </div>
                                                <div :id="'collapse'+a" class="collapse" :aria-labelledby="'heading'+a" data-parent="#accordionExample">
                                                    <div class="card-body">
                                                        <!-- datos del organismo nieto -->
                                                        <p> <b>{{nieto.funcionario}}</b></p>
                                                        <p> {{nieto.conmutador}} <span v-if="nieto.conmutador && nieto.telefonodirecto"> - </span> {{nieto.telefonodirecto}} </p>
                                                        <p> {{nieto.domicilio}} {{nieto.colonia}} C.P. {{nieto.cp}} {{nieto.municipio}} </p>
                                                        <p> {{nieto.correo}}</p>

                                                        <div style="width:100%; border-bottom: .1rem dashed #ce232345; margin-top: .8rem;"></div>
                                                        <div v-for="(v1, v) in nieto.departamentos" :key="v">
                                                            <div class="cards-estilos">
                                                                <div v-for="(bisnietos, b) in v1" :key="b">
                                                                    <div class="card text-dark cards-st" style="max-width: 17.5rem;">
                                                                        <div class="card-header  bg-light">{{bisnietos.Organo}}</div>
                                                                        <div class="card-body estilos-p" >
                                                                            <!-- Datos del organo bisnieto -->
                                                                            <p>{{bisnietos.Funcionario}}</p>
                                                                            <p>{{bisnietos.domicilio}} {{bisnietos.colonia}} C.P. {{bisnietos.cp}} {{bisnietos.municipio}}, Chiapas</p>
                                                                            <p>{{bisnietos.conmutador}}<span v-if="bisnietos.conmutador && bisnietos.telefonodirecto"> - </span> {{bisnietos.telefonodirecto}}</p>
                                                                            <p>{{bisnietos.Correo}}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>                                                        
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>                                                            
                                            </div>               
                                        </div>
                                    </div>
                                </div>
                            </div>                                           
                        </div>                                   
                    </div>
                </div>
            </div>
            <!-- ================================================================================================== -->
            <!-- =====BUSQUEDA POR FUNCIONARIO===== -->
            <div v-show="toggle" class="opc-funcionario">
              <busqueda-funcionario></busqueda-funcionario>
            </div>


        </div>
    </div>
</template>
<script>
import axios from "axios";
import spiner from "./../../spiner.vue"
import busquedaFuncionario from "./directorio-funcionarios.vue"
import mensaje from '../../mensaje_secretario.vue'
import Api from "../../../services/config/api/axios.urlcontext"
export default {
    name: 'Directorio',
    components:{
        spiner,
        busquedaFuncionario,
        mensaje
    },
    data:function() {
        return{
            loading:true, //variable para el spiner
            //===Variables busqueda por organo==
            jsonDirectorio: 'https://api.chiapas.gob.mx/funcionarios/dependencia/43', //servicio 
            //jsonDirectorio: Api.APP_URL_API + '/Otros-Recursos/organos.json', //json montado en el servidor 
            data: null,
            nombreHijo: '',
            verCollapse: false,
            //===Variables switch===      
            toggle: false,
            color: '#621132',            
        }
    },
    created:function() {
        this.consultaDirectorioOrgano();
    },
    mounted(){
        window.scrollTo(0, 0);
    },
    methods:{
        llenadoSelect(idSelect){
            var listaOrganosHijo = this.data.organoshijos[0]
            // console.log("hola desde el metodo llenadoSelect", listaOrganosHijo, idSelect, this.loading);
            $("#"+idSelect).empty();
            $("#"+idSelect).append("<option hidden selected>Seleccione un Órgano</option>");
            $.each(listaOrganosHijo, function (indice, row) { 
                $.each(row, function(j, organo){
                    if(organo.IDPadre == 43){
                        // console.log(indice);
                        $("#" +idSelect).append("<option value='" + indice + "'>" + organo.Organo + "</option>");
                    }
                 });                  
            });
            
        },
        consultaDirectorioOrgano(){
            axios
            .get(this.jsonDirectorio)
            .then((res) => {
                this.data = res.data
                this.loading = false
                this.llenadoSelect('listaOrganos');          
            })
        },
        obtenerNieto(){
            this.verCollapse = true;
            this.nombreHijo = document.getElementById('listaOrganos').value;
            // console.log(this.nombreHijo);            
            if (this.nombreHijo === 'Seleccione un Órgano') return document.getElementById('error1').className = 'd-block error-estilos'; // Si el usuario selecciona la primera opción que es el placeholder poner el parrafo de advertencia
            else return document.getElementById('error1').className = 'd-none error-estilos'; //lo contrario no mostrar el parrafo de advertencia            
         },
    }
}

</script>
<style scoped>
/* margenes */
.margin_alto{margin: 6.5rem 0;}
.margin_normal{margin-bottom: 4rem;}
/* Estlo del spiner espacio de abajo */
.text-cargando{
    margin-bottom: 6rem;
}
/* <!-- =====CONTENEDOR IMAGEN Y MENSAJE DEL SRIO===== --> */
.contenedor-sh-mensaje{
    display: flex;
    justify-content: flex-start;
    /* flex-wrap: nowrap; */
}
/* Contenedor imagen de secretario */
.contenedor-sh-mensaje .img_sh{
    width: 25%;
    height: auto;
    margin-right: 1.5rem    
}
/* imagen */
.contenedor-sh-mensaje .img_sh img{
    width: 100%;    
    border-radius: 5px;
}
/* contenedor mensaje */
.contenedor-sh-mensaje .mensajesh_bienvenida{
    width: 65%;
    height: auto;
   
}
/* cuerpo de texto */
.contenedor-sh-mensaje .mensajesh_bienvenida p{
   font-size: 13.5pt;
   font-style: italic;
   font-weight: 300;
   text-align: justify;
   line-height: 1.8rem;
    margin-bottom: 3rem;
   
}
.contenedor-sh-mensaje .nombre-srio{
    /* color: #9d9d9d; */
    color: #6c757d;
    font-size: 15pt;
    font-weight: 500;
}
/* <!-- CONTENEDOR DATOS DEL SRIO --> */
.datos-srio-hacienda{
    margin-top: 1rem;
    
}
.linea{
    height: 2.6px;
    width: 54%;
    background-color: #afbbc5;
}
/* datos secretario */
.datos-srio-hacienda .secretario h3, .hacienda .datos-hacienda h3{
    font-weight: 500;
    font-size: 15pt;
    margin-top: 0.7rem;
    margin-bottom: 0;
}
.datos-srio-hacienda .secretario p{
    margin-bottom: 0;
}
/* datos hacienda */
.datos-srio-hacienda .hacienda{
    display: flex;
    margin-top: 0.5rem;
}

.datos-srio-hacienda .hacienda .logo-hacienda{
    width: 15%;
    height: auto;
    margin-right: 0.4rem;
}
.datos-srio-hacienda .hacienda .datos-hacienda{
    width: 70%;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: flex-end; 
}
 .datos-srio-hacienda .hacienda .datos-hacienda p{
        margin-bottom: 1.9rem;
}
/* color del <a></a> */
.datos-srio-hacienda .hacienda .datos-hacienda a{
    color: #212529;
}
/* hover del <a></a> */
.hacienda .datos-hacienda a:hover{
    color: #621132;
    font-weight: 500;
}
/* Leyenda "Busqueda por:" */
.text-busqueda{
    /* margin-top: 0.8rem; */
    margin-bottom: 0.5rem;
    text-align: center;
    font-size: 23px;
    color: #621132;
    font-weight: 500;
}
/* CONTENEDOR DEL SWITCH */
.contenedor-opcBusqueda{
    display: flex;
    justify-content: center;
}
.contenedor-opcBusqueda label{
    font-size: 19.5px;
    color: #621132;
    font-weight: 500;
}
.opc1{
    margin-right: 0.5rem;
}

.opc1, .opc2 {
    font-size: 18px;
    color: white;
}
/* Contenedor busqueda por organo */
.opc-organo, .opc-funcionario{
    margin-top: 2rem;
    
}
.contenedor-busquedaOrgano{
    display: flex;
    justify-content: space-around;
    
}
.contenedor-busquedaOrgano .select-organo{
    width: 65%;
}
.contenedor-busquedaOrgano .boton-organo{
    width: 25%;
}
.error-estilos{
    color:#b11a1a;
    margin-bottom:0;
    font-size: 13px;
    margin-bottom: 1.5rem;
    margin-left: 25%;
}

.datos_hijo{
    /* background-color: #f8f9fa; CHECAR ESTE COLOR */
    padding: 0 1.5rem 0 2rem;
    margin-top: 1rem;
}
.datos_hijo p{
 margin-bottom: 0rem   
}
  
 /* <!-- Area de collapses con los organos --> */
 .zona_collapse{
     padding-right: 0;
 }
.OrganoTitulo{
    font-size: 1.5rem;
    font-weight: 300;
    color:#fff;
    background: #702544de;
    padding: 1rem;
    border-bottom-right-radius: 22px;
    margin-top: 1.5rem;
}
.subtitulo2 { color: #545151; }
.card-header { background-color: #fff; }
.btn-link{ 
    color: #560f2c;
    font-size: 18px;
    letter-spacing: .3px;
}
.btn:focus { box-shadow: none; }
.btn-link:hover { text-decoration: none; }

.btn{ padding: 0 !important;}

.cards-estilos{
    display: flex;
    flex-wrap: wrap;
}
.cards-st{ 
    margin: 1rem;
    max-width: 18rem;
    min-height: 20rem;    
 }
.card-padre{
    border: 1px solid #fff ;
    border-bottom: 1px solid #cbcbcb78 !important;
    border-radius: 0 !important;
    margin-top: 1.5rem;
    
}

li{ 
    list-style:none;
    margin-bottom: 1rem;
    border-bottom: 1px dotted rgb(189, 182, 182);
    padding: .2rem;
    padding-left: 0 !important;
    font-size: 14px;
}
li a:hover{ color: #560f2c !important; text-decoration: none; }


/*  */

    .title_document { 
        padding: .8rem 1rem;             
        width: 100%;
        height: auto;
        border: 1px solid#dfdfdf ;
        border-radius: 5px;
        border-left: 3px solid #621132;

        display: flex;
        justify-content: space-between;
        align-items: center !important;
    } 

    .title_document:hover{
        box-shadow: 3px 8px 17px -13px rgba(0,0,0,0.75) !important;
    }

    .descargar{
        font-size: 0.9rem;
        color: #6c757d !important;
    }

   
    .title_document h5{
        font-size: 0.9rem;
        font-weight: 400;
        line-height: 20px;
    }

    .sec_imagen{ 
        width:85% !important;
        background-color: #560F2C;
        margin-top: 3rem;
    }

    a{
        text-decoration: none !important;
        color: #212529;
    }
    a:hover{ color:#212529 !important; }

    /* margenes de la card consulta */
    .margenes{
        display: flex !important;
        justify-content: flex-end !important;
    }
    .card-width{ width: 90%; }
    
    /* select */
    .form-control-lg {
        font-size: 1rem;
        border-radius: .4rem;
    }

    .tab-select{
        position: sticky !important;
        top: 15% !important;
        z-index: 1000 !important;
    }
    .card-body p{
    margin-bottom: 0.1rem !important; /***aqui */
    }
    .estilos-p{ font-size: 14px; }



/* ESTILOS PARA MOVILES */
@media only screen and (max-device-width : 900px){
    /* contenedor img y mensaje */
    .contenedor-sh-mensaje{
        flex-wrap: wrap;
    }
    /* Contenedor imagen de secretario */
    .contenedor-sh-mensaje .img_sh {
        display: flex;
        justify-content: center;
        width: 100%;
        height: auto;    
        margin-right: 0;
    }
    /* imagen */
    .contenedor-sh-mensaje .img_sh img{
        width: 70%;    
    }
    /* contenedor mensaje */
    .contenedor-sh-mensaje .mensajesh_bienvenida {      
        width: 100%;
        height: auto;
        margin-top: 1rem;
        text-align: center;
        margin-left: 0.5rem;
        margin-right: 0.5rem;
    }  
    .contenedor-sh-mensaje .mensajesh_bienvenida p{
        margin-bottom: 1rem;
    }

    /****datos secretario**** */
    .datos-srio-hacienda .secretario{
        margin: 0 0.5rem;
    }


    /* datos hacienda */
    .datos-srio-hacienda .hacienda{
        display: flex;
        flex-wrap: wrap;
        margin-top: 0.5rem;
    }

    .datos-srio-hacienda .hacienda .logo-hacienda{
        width: 100%;
        display: flex;
        justify-content: center;
    }
    .datos-srio-hacienda .hacienda .logo-hacienda img{
        width: 28%;
    }
    .datos-srio-hacienda .hacienda .datos-hacienda{
        width: 100%;
        text-align: center;
        margin: 0 0.5rem;
    }
    /* Contenedor busqueda por organo */
    .contenedor-busquedaOrgano{
        flex-wrap: wrap;
        justify-content: center;
    }
    .contenedor-busquedaOrgano .select-organo {
        width: 100%;
        margin-bottom: 1rem;
    }
    .contenedor-busquedaOrgano .boton-organo{
        width: 60%;
    }
    .contenedor-busquedaOrgano .boton-organo .btn{
        padding: 7px !important;
    }
    .datos_hijo{
        padding: 0 1.5rem 0 0.5rem;
        text-align: justify;
    }





    /* Estilos de los colapses */
    /* margenes de la card consulta */
    .OrganoTitulo{
        font-size: 1.35rem;
    }
    .cards-estilos{
        /* justify-content: center; */
        display: flex;
        justify-content: space-around;
    }
    .margenes{ justify-content: space-around !important; }
    .card-width{ width: 95%; }

    .subtitulo2{ font-size: 1rem; }

    .sec_imagen{ margin-top: 0rem; }

    .container{
        padding-right: 1% !important;
        padding-left: 1% !important;
    }

    .tab-select{
        position: initial;
        z-index: auto;
    }
        .cards-st{
        margin: .5rem 0;
        
        width: 17rem;
        height: 21rem; 
    }


    



}

</style>
